export default __webpack_public_path__ + "static/media/pics_on_laptop.33a80efd.png";